export const UPN = {
  ACTIVITY_TEXT: 'What happens? Define an active-verb based action, like "Create a case"',
  FLOWLINE_TEXT:
    'What is the unique,<br> verifiable, distinct<br> outcome?<br> ' +
    'E.g. "Case saved<br> in Salesforce<br> with ID, contact,<br> account,<br> and priority set"'
};

export const ARCHITECTURE = {
  ACTIVITY_TEXT: 'CardName',
  FLOWLINE_TEXT: 'Why?'
};

export const AGENT_INTERACTION = {
  RESOURCE_ACTIVITY_TYPES: {
    AI_AGENT: 'aiAgent',
    USER: 'user',
    FLOW: 'flow',
    APEX: 'apex'
  }
};

export const AGENT_INSTRUCTION = {
  ACTIVITY_TEXT:
    'What is the Agent supposed to do? Write a short instruction with active verb, like "Inform user that...". ' +
    'For longer instructions, add a rich text note to the Agent instruction box.',
  ACTIVITY_TEXT_ACTION:
    'Define active verb-based statement representing invoked automation, e.g. "Create a case"',
  ACTIVITY_TEXT_PROMPT:
    'Define active verb-based statement representing invoked prompt, e.g. "Create business proposal"',
  FLOWLINE_TEXT:
    'Write a unique, verifiable condition under which you expect the Agent to perform the activity, ' +
    'e.g. "User provides order number"',
  RICH_TEXT:
    '<b>Guardrail:</b><br> Define what your agent must never do or must always do, ' +
    'no matter the circumstances (this will be part of your Agent instructions)',
  RESOURCE_ACTIVITY_TYPES: {
    ACTION: 'action',
    PROMPT_TEMPLATE: 'promptTemplate',
    AI_AGENT: 'aiAgent'
  }
};

export const INTERACTION_FLOW = {
  RESOURCE_ACTIVITY_TYPES: {
    START: 'start',
    GET_RECORDS: 'getRecords',
    CREATE_RECORDS: 'createRecords',
    DELETE_RECORDS: 'deleteRecords',
    UPDATE_RECORDS: 'updateRecords',
    ROLLBACK_RECORDS: 'rollbackRecords',
    ASSIGNMENT: 'assignment',
    FILTER: 'filter',
    SORT: 'sort',
    DECISION: 'decision',
    PAUSE: 'pause',
    RECOMMENDATION_ASSIGNMENT: 'recommendationAssignment',
    LOOP: 'loop',
    WAIT: 'wait',
    SCREEN: 'screen',
    FLOW: 'flow',
    SEND_EMAIL: 'sendEmail',
    ACTION: 'action',
    CUSTOM_ERROR: 'customError',
    ADD_PROMPT_INSTRUCTIONS: 'addPromptInstructions'
  }
};

export const SYSTEM_ARCHITECTURE = {
  RESOURCE_ACTIVITY_TYPES: {
    SALESFORCE: 'salesforce',
    MULESOFT: 'mulesoft',
    TABLEAU: 'tableau',
    SLACK: 'slack',
    SALES_CLOUD: 'salesCloud',
    SERVICE_CLOUD: 'serviceCloud',
    REVENUE_CLOUD: 'revenueCloud',
    INDUSTRY_CLOUD: 'industryCloud',
    E_COMMERCE_CLOUD: 'eCommerceCloud',
    DATA_CLOUD: 'dataCloud',
    MARKETING_CLOUD: 'marketingCloud',
    AGENTFORCE: 'agentforce',
    HEROKU: 'heroku',
    INBOX: 'inbox',
    DATA: 'data',
    BOTS: 'bots',
    WEB: 'web',
    AUTHENTICATION: 'authentication',
    FUNCTION: 'function',
    ACCOUNT: 'account',
    ASSET: 'asset',
    CAMPAIGN: 'campaign',
    CASE: 'case',
    CONTACT: 'contact',
    CONTRACT: 'contract',
    EVENT: 'event',
    LEAD: 'lead',
    OPPORTUNITY: 'opportunity',
    ORDER: 'order',
    PRICEBOOK: 'pricebook',
    PRODUCT: 'product',
    QUOTE: 'quote',
    SHIPMENT: 'shipment',
    USER: 'user'
  }
};

export const CUSTOMER_JOURNEY = {
  DEFAULT_RESOURCES: {
    CUSTOMER: 'customer'
  },
  ACTIVITY_TEXT: 'What does the customer do? E.g. "Contact support for help"',
  FLOWLINE_TEXT:
    'What is the unique,<br> verifiable, distinct<br> customer outcome?<br>' +
    'E.g. "Customer notified<br> of raised case,<br> with a unique ID,<br> via email notification"'
};
